import type { IconProps } from './types';

export const DisableIcon = (props: IconProps) => {
  const {
    size = 20,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      stroke={color}
      className={className}
    >
      <path
        d="M9.99999 18.57C5.26691 18.57 1.42999 14.7331 1.42999 10C1.42999 5.26692 5.26691 1.43 9.99999 1.43C14.7331 1.43 18.57 5.26692 18.57 10C18.57 14.7331 14.7331 18.57 9.99999 18.57Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0649 16.0649L3.93503 3.9351"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
